<template>
 <div class="">
    <div class="page_part6">
        <div class="table">
        <table>
          <thead>
            <tr>
              <th rowspan="2">适应性维度</th>
              <th rowspan="">水平值</th>
              <th rowspan="2">正常范围</th>
              <th colspan="5">等级</th>
            </tr>
            <tr>
              <th width="80"></th>
              <th width="80"></th>
              <th width="80"></th>
              <th width="80"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(m, index) in arrResole" :key="index">
              <td>{{ m.name }}</td>
              <td>{{ m.value }}</td>
              <td>0-3.50</td>
              <td colspan="5">
                <div class="line_box">
                  <div
                    :class="['line_score', getBgColor(m.value)]"
                    :style="{ width: (m.value / 5) * 242 + 'px' }"
                    :title="m.value"
                  ></div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>
 </div>
</template>

<script>

export default {
  props:{
    mind:{
      type:Object,
    },
    result:{
      type:Array
    }
  },
  data(){
    return{
      index:[0,1,2,3,4,5,6,7],
      tableArr: ["学习焦虑", "对人焦虑", "自责倾向", "冲动倾向"],
    }
  },
  computed:{
     arrResole() {
      let arr = [];
      for (var i = 0; i < this.tableArr.length; i++) {
        this.result.forEach((item) => {
          if (this.tableArr[i] == item.name) {
            arr.push(item);
          }
        });
      }
      return arr
    },
  },
  created(){


  },
  mounted(){

    // this.$nextTick(() =>{
    //   this.setCanvas()
    // })

  },
  methods:{
    forId(index){
      return "canvasId"+index
    },
    getColor(value) {
      if (value >= 0 && value <= 1.5) {
        return "Ycolor1";
      } else if (value > 1.5 && value <= 3.5) {
        return "Ycolor2";
      } else if (value > 3.5 && value <= 5) {
        return "Ycolor3";
      }
    },
    getBgColor(value) {
      if (value >= 0 && value <= 1.5) {
        return "c_mind1";
      } else if (value > 1.5 && value <= 3.5) {
        return "c_mind2";
      } else if (value > 3.5 && value <= 5) {
        return "c_mind3";
      }
    },
    setCanvas() {
      //   let canvasId = this.canvasId;

      for(var i = 0;i<this.mind.result.length;i++){
        var key = "canvasId"+i
        let ctx = document.getElementById(key).getContext('2d')
        ctx.beginPath(); //起始路径，重置当前路径
        // ctx.strokeStyle="#FCE5E0";
        ctx.strokeStyle="rgba(121,119,119,.1)";

        ctx.lineWidth = 55;  //设置或返回当前的线条宽度。
        ctx.lineCap = 'butt'; //设置或返回线条的结束端点样式。
        ctx.arc(126,127,60, (0.825+5/5*244/180) * Math.PI,(6/5*244/180+0.825)  * Math.PI); //4个刻度平分180°
        ctx.stroke()
        ctx.closePath()

        //橙色圈
        ctx.beginPath(); //起始路径，重置当前路径
        let lingrad = ctx.createLinearGradient(40,20,215,20);//创建线性渐变，颜色渐变
        lingrad.addColorStop(0, '#FDAB74');
        lingrad.addColorStop(1, '#FE8E84');

        ctx.strokeStyle = lingrad; //设置或返回用于笔触的颜色、渐变或模式。
        ctx.lineWidth = 10;  //设置或返回当前的线条宽度。
        ctx.lineCap = 'round'; //设置或返回线条的结束端点样式。

        ctx.arc(127,127,101, 0.825 * Math.PI,(4/5*244/180+0.825) * Math.PI); //4个刻度平分180°
        ctx.stroke()
        ctx.closePath()
      }

    }
  },
};
</script>

<style scoped>
@import './report.css';

.page_part3 h5.page_bg_o {
  background-color: #feae3b;
}
.c_mind1{
  background: #09B351;
}
.c_mind2{
  background: #FEAE3B;
}
.c_mind3{
  background: #FF0000;
}
.Ycolor3 span{
  color: #FF0000;
}
.Ycolor2 span{
  color: #F6A724;
}
.Ycolor1 span{
  color: #09B351;
}
h5.header {
  color: #fff;
  font-size: 24px;
  text-align: left;
  margin-bottom: 30px;
  line-height: 50px;
  padding-left: 15px;
}
.page_title_2 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  height: 32px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
}
.page_part2 .page_title_2 .arrow {
}
h5.page_bg_bl {
  background-color: #feae3b;
}
.page_title_2 span {
  line-height: 32px;
  font-size: 20px;
  font-weight: 700;
}
.page_title_2 .arrow {
  display: block;
  margin-left: 10px;
  width: 0;
  height: 0;
  border-top: 9px solid transparent;
  border-left: 14px solid #feae3b;
  /* border-left: 14px solid #19b1c4; */
  border-bottom: 9px solid transparent;
}
.header_detail_box .header_detail {
  text-indent: 2em;
  line-height: 32px;
  font-size: 15px;
  color: #4f4e4e;
}

.line_box2 {
  margin-top: 40px;
}

.table {
  margin-top: 20px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}
.table tr th {
  color: #fff;
  font-size: 16px;
  line-height: 42px;
  background-color: #f6a724;
  border: 1px solid #fff;
  text-align: center;
}

.table tr td {
  font-size: 14px;
  height: 60px;
  text-align: center;
  background-color: #f7f7f7;
  border: 1px solid #fff;
}
.table tr td .line_box {
  height: 20px;
  position: relative;
}
.table tr td .line_box .line_score {
  height: 20px;
}
.table tr td .line_box .lien_norm {
  position: absolute;
  top: 0;
  height: 20px;
  background: rgba(121, 119, 119, 0.55);
}

.c_mind5 {
  background-color: #90d246;
}


</style>

<style type="text/css" lang='less' scoped>
.part4_2_main_box {
  margin-top: 40px;
  .main_title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .part4_2_main {
    display: flex;
    .norm_box {
      text-align: center;
      .norm_canvas {
        width: 254px;
        height: 201px;
        position: relative;
        background: url(~@/assets/report_imgs/part4_canvas.png);
        .pointer {
          position: absolute;
          height: 194px;
          left: 113.5px;
          top: 30px;
        }
      }
      .detail_box {
        p {
          line-height: 28px;
          font-size: 16px;
        }
        .title {
          font-weight: bold;
        }
        .score {
          color: #8a8a8a;
          span {
            font-weight: bold;
            color: #F8AF3E;
            font-size: 16px;
          }
        }
        .norm {
          color: #8a8a8a;
          span {
            font-weight: bold;
            color: #50CFB1;
            font-size: 16px;

          }
        }
      }
    }
    .comment_warp{
      padding: 30px;
      box-sizing: border-box;
      width: 456px;
      .score{
        font-size: 16px;
        font-weight: 500;
        color: #333;
        margin-bottom: 5px;
        span{
          // color: #00B14B;
          font-weight: 600;
        }
      }
      .comment {
        font-size: 14px;
        color: #8a8a8a;
        line-height: 1.5;
        margin-top: 15px;
      }
    }
  }

}
</style>